export const linkType = {
  SELF: 'self',
  BLANK: 'blank',
  CALLBACK: 'callback',
};
